export const splitSummary = (summary) => {
    if (!summary) return [];

    return summary
        // 소수점 처리
        .replace(/(\d)\.(?=\d)/g, '$1__DOT__')
        // 문장 부호(.?!) 기준으로 분리
        .split(/([.?!])/)
        .map(part => part.trim()) // 각 부분의 앞뒤 공백 제거
        .filter(part => part.length > 0) // 빈 문자열 제거
        .reduce((acc, curr) => {
            if (/[.?!]/.test(curr)) {
                // 현재 요소가 문장 부호인 경우, 이전 요소와 합쳐서 완료된 문장으로 추가
                if (acc.length > 0) {
                    acc[acc.length - 1] = `${acc[acc.length - 1]}${curr}`.replace(/\s+/g, ' ').replace(/\n+/g, '');
                } else {
                    acc.push(curr);
                }
            } else {
                // 현재 요소가 텍스트인 경우, 이전 문장에 추가하거나 새로운 문장으로 시작
                if (acc.length > 0 && !/[.?!]/.test(acc[acc.length - 1])) {
                    acc[acc.length - 1] = `${acc[acc.length - 1]} ${curr}`.replace(/\s+/g, ' ').replace(/\n+/g, '');
                } else {
                    acc.push(curr.replace(/\s+/g, ' ').replace(/\n+/g, ''));
                }
            }
            return acc;
        }, [])
        // 임시 소수점 복원
        .map(sentence => sentence.replace(/__DOT__/g, '.'))
        .filter(sentence => sentence.length > 0);
};